var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert alert-light border d-flex align-items-center"},[_c('i',{staticClass:"fa-solid fa-wifi mr-3"}),_c('div',[_c('h6',{staticClass:"font-weight-bold mb-0"},[_vm._v("Desconectado")]),_c('p',{staticClass:"mb-0"},[_vm._v("Verifique sua conexão com a Internet")])])])
}]

export { render, staticRenderFns }